import CONTRACT from './abis/METEST.json';
import NODE_MGR from './abis/NodeManager.json';
export const CONTRACT_ABI = CONTRACT.abi;
export const NODE_MGR_ABI = NODE_MGR.abi;

//export const CONTRACT_ADDRESS = '0x5B01913431B26a2017FEaaFcA46a716d4D8Ee3eF'; 
//export const CONTRACT_ADDRESS = '0x863a76206c29Ddc087c91e1F646cB8Ed60207042'; 
//export const CONTRACT_ADDRESS = '0x032Cc6DD9c08367d743aD11bcAE7a2003B0DfC8c';
//export const CONTRACT_ADDRESS = '0x26549a2c9f6ecA4BB470f2D616fD47a6af0b5Ed6';
export const CONTRACT_ADDRESS = '0xfbc94a6baA5AE1ad140a3D9338511D8859183CCf';


//export const NODE_MANAGER_ADDRESS ='0x16EA324EAb62390f2eC2FE7a6AE6bF80fd1f6095'; 
export const NODE_MANAGER_ADDRESS ='0x8602250f0a4b27810fef90c7acd380c3cb7b272d'; 
export const CHAIN_ID = 0xa86a;
export const TEST_NET_URL =  'https://data-seed-prebsc-1-s1.binance.org:8545';
